import React from 'react';
import { Factory, Swords } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { SearchPicker } from '../SearchPicker';

export const productOptionsFor = (products) => products.map(p => ({ value: p.id, label: p.product_sku ? `${p.product_sku} — ${p.product_type_name}` : p.product_type_name }));

// Two-button "whose machine" switch, shared with machine rows.
export const OwnerToggle = ({ competitor, onChange, disabled, testId, compact }) => (
  <div className={`inline-flex rounded-sm border border-slate-300 overflow-hidden ${compact ? 'text-[11px]' : 'text-xs'}`} data-testid={testId}>
    {[[false, 'Our product', Factory], [true, 'Competitor', Swords]].map(([val, label, Icon]) => (
      <button key={label} type="button" disabled={disabled} onClick={() => onChange(val)}
        className={`flex items-center gap-1 px-2 ${compact ? 'h-9' : 'h-8'} transition-colors ${!!competitor === val ? (val ? 'bg-red-600 text-white' : 'bg-slate-900 text-white') : 'bg-white text-slate-600 hover:bg-slate-50'} disabled:opacity-60`}
        data-testid={`${testId}-${val ? 'competitor' : 'ours'}`}>
        <Icon className="w-3 h-3" />{compact ? (val ? 'Comp.' : 'Ours') : label}
      </button>
    ))}
  </div>
);

export const BrandDatalist = ({ brands }) => (
  <datalist id="ro-competitor-brands">{brands.map(b => <option key={b} value={b} />)}</datalist>
);

export const RepairProductCard = ({ form, setForm, editable, products }) => {
  const set = (patch) => setForm(f => ({ ...f, ...patch }));
  const pickProduct = (pid) => {
    const p = products.find(x => x.id === pid);
    set(p ? { product_type_id: p.id, product_sku: p.product_sku || '', product_name: p.product_type_name } : { product_type_id: '' });
  };
  const setOwner = (comp) => set(comp
    ? { is_competitor: true, product_type_id: '', product_sku: '' }
    : { is_competitor: false, competitor_brand: '' });
  return (
    <Card className="industrial-card">
      <CardHeader className="border-b border-slate-100 pb-3 flex flex-row items-center justify-between">
        <CardTitle className="text-base">Product Details</CardTitle>
        <OwnerToggle competitor={form.is_competitor} onChange={setOwner} disabled={!editable} testId="ro-owner-toggle" />
      </CardHeader>
      <CardContent className="p-4 grid grid-cols-2 md:grid-cols-4 gap-3">
        {form.is_competitor ? (
          <>
            <div className="col-span-2"><Label>Competitor brand *</Label>
              <Input list="ro-competitor-brands" value={form.competitor_brand || ''} onChange={(e) => set({ competitor_brand: e.target.value })} disabled={!editable} placeholder="e.g. Harvest Right" className="rounded-sm" data-testid="ro-competitor-brand" />
            </div>
            <div className="col-span-2"><Label>Product Name *</Label><Input value={form.product_name} onChange={(e) => set({ product_name: e.target.value })} disabled={!editable} placeholder="e.g. Large Home Pro freeze dryer" className="rounded-sm" data-testid="ro-product-name" /></div>
          </>
        ) : (
          <>
            <div className="col-span-2"><Label>Product (from your catalog)</Label>
              <SearchPicker value={form.product_type_id || ''} options={productOptionsFor(products)} onChange={pickProduct} disabled={!editable} placeholder="— pick a product —" testId="ro-product-select" />
            </div>
            <div><Label>Product SKU</Label><Input value={form.product_sku || ''} onChange={(e) => set({ product_sku: e.target.value.toUpperCase() })} disabled={!editable} className="rounded-sm mono" data-testid="ro-product-sku" /></div>
            <div><Label>Product Name *</Label><Input value={form.product_name} onChange={(e) => set({ product_name: e.target.value })} disabled={!editable} className="rounded-sm" data-testid="ro-product-name" /></div>
          </>
        )}
        <div><Label>Serial Number</Label><Input value={form.product_serial} onChange={(e) => set({ product_serial: e.target.value })} disabled={!editable} className="rounded-sm mono" data-testid="ro-product-serial" /></div>
        <div><Label>Model</Label><Input value={form.product_model} onChange={(e) => set({ product_model: e.target.value })} disabled={!editable} className="rounded-sm mono" data-testid="ro-product-model" /></div>
        <div className="col-span-2"><Label>Original Purchase Date</Label><Input type="date" value={form.original_purchase_date} onChange={(e) => set({ original_purchase_date: e.target.value })} disabled={!editable} className="rounded-sm" data-testid="ro-purchase-date" /></div>
      </CardContent>
    </Card>
  );
};
